
<div class="page-wrapper"
[ngClass]="{ 'is-authorized': isAuthorized, 'is-not-authorized': !isAuthorized }">
<nz-page-header 
*ngIf="!isAuthorized"
[nzTitle]="customTitle" 

 class="custome-header"
 ></nz-page-header>

<ng-template #customTitle>
  <span class="catalog-title"> {{catalogName}}</span>
</ng-template>

<div  [ngClass]="{'page-content':!isAuthorized}">

<div class="custome-breadcrumb" *ngIf="!isLoading && productDetails">

  <nz-breadcrumb>
    <div  class="back-icon">
      <a [routerLink]="['/product-catalog/catalog-cards', id, catalogCode]">
        <i nz-icon nzType="left" nzTheme="outline"></i>
      </a>
    </div>
    <nz-breadcrumb-item>
      <a [routerLink]="['/product-catalog/catalog-cards', id, catalogCode]">
        {{ catalogName }}
      </a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>{{productDetails.name}}</nz-breadcrumb-item>
  </nz-breadcrumb>
</div>
<div *ngIf="isLoading" class="loading-container">
  <nz-spin nzSimple nzSize="large"></nz-spin>
</div>



<div class="countainer" *ngIf="!isLoading && productDetails">
  <div nz-row>
    <div nz-col nzSpan="12">
      <div class="main-image">
        <!-- <img [src]="productDetails.mainImage ?  (productDetails.mainImage | safeHtml:'url') : '../../../assets/test.png'"
          alt="Product Image "> -->
          <img
          [src]="selectedImage ? (selectedImage | safeHtml:'url') : '../../../assets/test.png'"
          alt="Product Image"
        />

      </div>
      <nz-row [nzJustify]="'center'">
        <div class="thumbnails">
          <img *ngFor="let img of productDetails.images"
           [src]="img ? (img  | safeHtml:'url') : '../../../assets/test.png'"
          alt="Thumbnail"
          
             [class.active]="img === selectedImage"
            (click)="selectImage(img)">
        </div>
      </nz-row>

    </div>


    <div nz-col nzSpan="12">

      <span class="product-label">{{'Product No' | translate}} {{productDetails.sku}}</span>
      <h1 class="product-title">{{productDetails.name}}</h1>

      <span class="product-price" *ngIf="productDetails.price; else noPrice">
        <!-- {{ productDetails.price }} {{productDetails.currency}} -->
          {{ productDetails.price | priceFormat:productDetails.currency }}
      </span>

      <ng-template #noPrice><span>{{'Not Available Price' | translate}}</span></ng-template>


      <nz-divider style="margin: 10px 0 !important; "></nz-divider>
      <span style="font-size: 17px;margin-bottom: 15px; display: inline-block;">{{'Description' | translate}}</span>

      <p> {{productDetails.description}}</p>

      <nz-list nzBordered  class="attributes-list"
       >

        <nz-list-item *ngFor="let itme of productDetails.attributes">
          <span nz-typography>{{ itme.name }}</span>

          <img *ngIf="isImagePath(itme.value)"
          [src]="transformImagePath(itme.value)"
          alt="Image"
          style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; margin-top: 8px;" />
     

    <span *ngIf="!isImagePath(itme.value)">{{ itme.value }}</span>
        </nz-list-item>

      </nz-list>
    </div>
  </div>

</div>

</div>
<footer  class="custom-footer" *ngIf="!isAuthorized">
  <div class="catalog-title ">{{catalogName}}</div>
  <div class="footer-right">{{'All rights reserved' | translate}}</div>
</footer>

</div>